export function isSiteAdmin(groups) {
  return groupCheck("Site Admin", groups);
}

export function isContentWriter(groups) {
  return groupCheck("Content Writer", groups);
}

export function isToolSub(groups) {
  return groupCheck("Tools Subscriber", groups);
}

function groupCheck(tgtGroup, groups) {
  return (
    groups && groups.find((group) => group.name === tgtGroup) !== undefined
  );
}
